import { axiosApiInstance, axiosStorageInstance } from "../axios";

function apiError(error) {
  const errorStatus = error.response?.status;

  return {
    success: false,
    data: error.response?.data || {
      title: "Error",
      subtitle: "We could not complete the action.",
    },
    errorStatus,
  };
}

export async function makePostApiCall(endPoint, payload, contentType) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType ? contentType : "application/json",
    },
  };

  return axiosApiInstance
    .post(endPoint, payload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch(apiError);
}

export async function makePutApiCall(endPoint, payload, contentType) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType ? contentType : "application/json",
    },
  };

  return axiosApiInstance
    .put(endPoint, payload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch(apiError);
}

export async function makePatchApiCall(endPoint, payload, contentType) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
      "content-type": contentType ? contentType : "application/json",
    },
  };

  return axiosApiInstance
    .patch(endPoint, payload, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch(apiError);
}

export async function makeGetApiCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosApiInstance
    .get(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch(apiError);
}

export async function makeDeleteApiCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosApiInstance
    .delete(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch(apiError);
}

export async function makeGetCall(endPoint) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  return axiosStorageInstance
    .get(endPoint, config)
    .then((response) => {
      return {
        success: true,
        data: response.data,
      };
    })
    .catch(apiError);
}
